import * as helpDeskTypes from "../../types/admin/helpDeskTypes";

//Get All Tickets
export const getAllTicketsReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case helpDeskTypes.GET_ALL_TICKETS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case helpDeskTypes.GET_ALL_TICKETS_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case helpDeskTypes.GET_ALL_TICKETS_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};

//Create Ticket
export const createTicketReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case helpDeskTypes.CREATE_TICKET_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case helpDeskTypes.CREATE_TICKET_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case helpDeskTypes.CREATE_TICKET_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};

//Update Ticket
export const updateTicketReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case helpDeskTypes.UPDATE_TICKET_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case helpDeskTypes.UPDATE_TICKET_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case helpDeskTypes.UPDATE_TICKET_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};

//Archive Ticket
export const archiveTicketReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case helpDeskTypes.ARCHIVE_TICKET_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case helpDeskTypes.ARCHIVE_TICKET_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case helpDeskTypes.ARCHIVE_TICKET_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};

// Add Comment
export const addCommentReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case helpDeskTypes.ADD_COMMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case helpDeskTypes.ADD_COMMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case helpDeskTypes.ADD_COMMENT_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};

//getCommentForOneTicket
export const getCommentForOneTicketReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case helpDeskTypes.GET_COMMENTS_FOR_ONE_TICKET_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case helpDeskTypes.GET_COMMENTS_FOR_ONE_TICKET_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case helpDeskTypes.GET_COMMENTS_FOR_ONE_TICKET_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};

//deleteComment
export const deleteCommentReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case helpDeskTypes.DELETE_COMMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case helpDeskTypes.DELETE_COMMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case helpDeskTypes.DELETE_COMMENT_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};
